import { isDevMode, Injectable } from '@angular/core';

@Injectable()
export class convertConfig {

  apiRoutes: any;
  backendKazEntConvert: any;

  constructor() {
    if (isDevMode()) {
      this.backendKazEntConvert = 'https://app.debug.testcenter.kz/kaztest-ent-convert/api/v1';
    }
    if (!isDevMode()) {
      this.backendKazEntConvert = 'kaztest-ent-convert/api/v1';
    }

    this.apiRoutes = {
    };

  }
}
